<template>
  <HydrusRating
    v-for="(activeRating, key) in props.activeRatings"
    :key="key"
    :rating="activeRating"
    :show-buttons="true"
    @set="(newRating, oldRating) => { console.log('MetaRating.emit', ['rate', key, newRating]); emit('rate', key as ServiceHash, newRating) }"
  />
</template>

<script lang="ts">
import type { ActiveRating } from "@/components/meta/types";
import type { ServiceHash } from "@/stores/ImageMetadata";
import type { AnyValue } from "@/stores/ratingService";

export type Props = {
  activeRatings: ActiveRating;
}
export type Emits = {
  (e: "rate", key: ServiceHash, newRating: AnyValue): void;
}
</script>
<script setup lang="ts">
import HydrusRating from "@/components/HydrusRating/index.vue";
import { defineProps, defineEmits } from "vue";

const props = defineProps<Props>();
const emit = defineEmits<Emits>();
</script>

<style scoped lang="scss">
$min_px_width_for_desktop_layout: 800px;
</style>

<style>
.vote-overlay svg {
  width: 4em;
  height: 4em;
}
</style>
